import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'

import { Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../common'
import { CurrencyText } from '../../common'

interface RemainingCashProps {
  remaining: number
}

const RemainingCash = ({ remaining }: RemainingCashProps) => {
  const { cashflow: customCopy } = useGlobalCopyStore()

  const getRemainingCashColor = () => {
    if (remaining < 0) {
      return 'error.main'
    }
    if (remaining > 0) {
      return 'success.main'
    }
    return 'warning.main'
  }

  return (
    <>
      <Box
        sx={{
          borderRadius: '1px',
          backgroundColor: getRemainingCashColor(),
          height: 6,
          width: 6,
        }}
      />
      <Text bold={true} sx={{ flexGrow: 1, fontSize: 12 }}>
        {customCopy.remaining_cash}
      </Text>
      <CurrencyText amount={remaining} bold={true} sx={{ fontSize: 12 }} />
    </>
  )
}

export default observer(RemainingCash)
